
    import {
        instrumentAll,
        groupInstrumentCountByLevel,
        groupInstrumentCountByYear,
        groupInstrumentCountByShape
    } from "../../../js/referenceMaterial/referenceMaterial";
    import {Component, Vue, Watch} from "vue-property-decorator";
    import SetTableColumns from "@/components/SetTableColumns.vue";
    import echarts from "echarts";
    import {userApi} from "@/api/organization";
    import {IPage} from "@/js/page";

    @Component({
        name: "Material_Index",
        components: {SetTableColumns}
    })
    export default class Home extends Vue {
        title = '';
        mode = '0' //0按级别  1按年 2按形态
        tableList = [];
        listParam: IPage = {
            size: 10,
            current: 1,
        };
        listTotal = 0;
        showForm = false;
        propParams = {
            证书编号: "",
            等级: "",
            标准物质名称: "",
            标准物质研制机构: "",
        }
        myChart = null as any;
        fullScreen = false;


        mounted() {
            if(this.$route.path == "/statistics/materialIndexs/0"){
                this.fullScreen = true;
            }
            this.mode = this.$route.params.mode;
            this.handleClick();
        }

        @Watch("mode")
        getMode(){
            this.handleClick();
        }

        handleClick(){
            this.updateTitle();
            if (this.mode == '0') {
                this.loadGroupInstrumentCountByLevel();
            } else if (this.mode == '1') {
                this.loadGroupInstrumentCountByYear();
            } else {
                this.loadGroupInstrumentCountByShape();
            }
            this.loadListOcrPageJump(1);
        }

        updateTitle() {
            switch (this.mode) {
                case '0':
                    this.title = "按级别统计";
                    break;
                case '1':
                    this.title = "按年统计";
                    break;
                case '2':
                    this.title = "按形态统计";
                    break;
                default:
                    this.title = "";
            }
        }

        indexMethod(index: any) {
            return (this.listParam.current - 1) * this.listParam.size + index + 1;
        }

        loadGroupInstrumentCountByLevel() {
            const tableData = groupInstrumentCountByLevel;
            // const xAxisData = tableData.map((t: any) => t.name);
            // const seriesData = tableData.map((t: any) => t.value);
            this.loadEchartPie(tableData);
        }

        loadGroupInstrumentCountByYear() {
            const tableData = groupInstrumentCountByYear;
            const xAxisData = tableData.map((t: any) => t.name);
            const seriesData = tableData.map((t: any) => t.value);
            const dataZoom = [
                {
                    show: true,
                    realtime: true,
                    start: 0,
                    end: 50
                },
                {
                    type: 'inside',
                    realtime: true,
                    start: 0,
                    end: 50
                }
            ]
            this.loadEchart(xAxisData, seriesData, dataZoom);
        }

        loadGroupInstrumentCountByShape() {
            const tableData = groupInstrumentCountByShape;
            // const xAxisData = tableData.map((t: any) => t.name);
            // const seriesData = tableData.map((t: any) => t.value);
            this.loadEchartPie(tableData);
        }

        loadEchart(xAxisData: any, seriesData: any, dataZoom: any) {
            if(this.myChart){
                this.myChart.dispose();
            }
            this.myChart = echarts.init(this.$refs.chart1);
            this.myChart.setOption({
                title: {
                    text: this.title
                },
                tooltip: {},
                xAxis: {
                    data: xAxisData
                },
                yAxis: {},
                dataZoom: dataZoom,
                series: [
                    {
                        name: '标准物质',
                        type: 'bar',
                        data: seriesData,
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 1, 1, 0, [{
                                    offset: 0,
                                    color: "#1268f3" // 0% 处的颜色
                                }, {
                                    offset: 0.6,
                                    color: "#08a4fa" // 60% 处的颜色
                                }, {
                                    offset: 1,
                                    color: "#01ccfe" // 100% 处的颜色
                                }], false)
                            },
                        },
                        label: {
                            show: true, //开启显示
                            position: 'top', //在上方显示
                            textStyle: { //数值样式
                                color: 'red',
                                fontSize: 16
                            }
                        }
                    }
                ]
            });
        }

        loadEchartPie(tableData: any) {
            if(this.myChart){
                this.myChart.dispose();
            }
            this.myChart = echarts.init(this.$refs.chart1);
            this.myChart.setOption({
                title: {
                    text: this.title
                },
                tooltip: {},
                color: ['#08a4fa', '#FF7A7A', '#33CC99', '#FF9393'],
                series: [
                    {
                        name: '标准物质',
                        type: 'pie',
                        radius: '85%',
                        data: tableData,
                        itemStyle: {
                            shadowBlur: 200,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        },
                        label: {
                            normal: {
                                formatter: '{a|{b}-{c}}',
                                position: 'inner',
                                rich: {
                                    a: {
                                        color: '#000',
                                        fontSize: 11,
                                        lineHeight: 20,
                                        align: 'center'
                                    }
                                }
                            },
                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            });
        }

        pageSizeChange(val: number) {
            this.listParam.size = val;
            this.loadListOcrPageJump(1);
        }

        pageCurrentChange(val: number) {
            this.listParam.current = val;
            this.loadListOcrPageJump(val);
        }

        //前台分页
        loadListOcrPageJump(currPage: number) {
            //筛选条件
            let resultList = JSON.parse(JSON.stringify(instrumentAll));
            const {证书编号, 等级, 标准物质名称, 标准物质研制机构} = this.propParams;
            if(证书编号 != ''){
                resultList = resultList.filter((r: any) => r.证书编号.indexOf(证书编号) > -1);
            }
            if(等级 != ''){
                resultList = resultList.filter((r: any) => r.等级 == 等级);
            }
            if(标准物质名称 != ''){
                resultList = resultList.filter((r: any) => r.标准物质名称.indexOf(标准物质名称) > -1);
            }
            if(标准物质研制机构 != ''){
                resultList = resultList.filter((r: any) => r.标准物质研制机构.indexOf(标准物质研制机构) > -1);
            }
            const newArr = resultList;

            const index = currPage; //从 1开始的页数
            const step = this.listParam.size;  //一页的数据量
            const d = newArr.length;
            const start = (index - 1) * step;  //
            const end = index * step > d ? d : index * step;
            this.tableList = newArr.slice(start, end);
            this.listTotal = newArr.length;
        }

        refresh() {
            this.listParam.current = 1;
            this.loadListOcrPageJump(1);
        }

        reset() {
            this.propParams.证书编号 = '';
            this.propParams.等级 = '';
            this.propParams.标准物质名称 = '';
            this.propParams.标准物质研制机构 = '';
            this.refresh();
        }
    }
